
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Calque_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 16.5 17.2","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M15.2 2.1h-3.6L10.7.3c-.1-.2-.3-.3-.5-.3H6.3c-.2 0-.4.1-.5.3l-.9 1.8H1.3c-.3 0-.6.3-.6.6s.3.6.6.6h.9v11.5c0 1.3 1.1 2.4 2.4 2.4H12c1.3 0 2.4-1.1 2.4-2.4V3.3h.9c.3 0 .6-.3.6-.6s-.4-.6-.7-.6zm-8.5-.9h3.1l.5.9h-4l.4-.9zM11.9 16H4.6c-.7 0-1.2-.5-1.2-1.2V3.3h9.8v11.5c-.1.7-.6 1.2-1.3 1.2z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M8.2 4.5c-.3 0-.6.3-.6.6v9.2c0 .3.3.6.6.6s.6-.3.6-.6V5.1c0-.4-.2-.6-.6-.6zM10.8 4.5c-.3 0-.6.3-.6.6v9.2c0 .3.3.6.6.6s.6-.3.6-.6V5.1c0-.4-.3-.6-.6-.6zM5.7 4.5c-.3 0-.6.3-.6.6v9.2c0 .3.3.6.6.6s.6-.3.6-.6V5.1c0-.4-.3-.6-.6-.6z"}})])
          )
        }
      }
    